import { PrivateInterceptor } from "../../Base/interceptors/PrivateInterceptor";



// ***********************CALENDARIO MENSUAL*************************

// OBTENER CALENDARIO MENSUAL
export const getCalendarioMensual = async () => {
  const respuesta = await PrivateInterceptor(`CalendarioOperativo/CalendarioMensual`, "GET");
  return respuesta;
};

export const getCalendarioMensual2 = async () => {
  const respuesta = await PrivateInterceptor(`CalendarioOperativo/CalendarioMensual/mensual`, "GET");
  return respuesta;
};

// OBTENER LA TASA DE CAMBIO DEL MES ACTUVO 
export const getTasaCambio = async () => {
  const respuesta = await PrivateInterceptor(`CalendarioOperativo/CalendarioMensual/TasaCambioMesActivo`, "GET");
  return respuesta;
};

// OBTENER TASA DE CAMBIO SEGÚN LA FECHA DE FACTURA
export const getTasaCambioPorFecha = async (fecha) => {
  const respuesta = await PrivateInterceptor(
    `CalendarioOperativo/CalendarioMensual/TasaCambioPorFecha/${fecha}`,
    "GET"
  );

  return respuesta;
};

// EDITAR CALENDARIO MENSUAL
export const EditarCalendarioMensual = (datos, datosSemanas) => {
  const respuesta = PrivateInterceptor("CalendarioOperativo/CalendarioMensual/EditarCalendarioMensual", "POST", {datos, datosSemanas});
  return respuesta;
};



// ***********************CALENDARIO SEMANAL*************************

// OBTENER CALENDARIO MENSUAL
export const getCalendarioSemanalxMes = async (IdMes) => {
  const respuesta = await PrivateInterceptor(`CalendarioOperativo/CalendarioSemanal/${IdMes}`, "GET");
  return respuesta;
};

export const getCalendarioSemanal = async () => {
  const respuesta = await PrivateInterceptor(`CalendarioOperativo/CalendarioSemanal/semanal`, "GET");
  return respuesta;
};


// *********************** FECHAS CIERRES DE INVENTARIO *************************
export const getFechasCierreInventario = async(IdMes) =>{
  const result = await PrivateInterceptor(`CalendarioOperativo/CierreInventario/${IdMes}`, 'GET');
  return result;
}

export const getReferencias = async () =>{
  const result = await PrivateInterceptor(`CalendarioOperativo/ReferenciaInv`, 'GET')
  return result
}



export const updateFechasCierreInventario = async(data) =>{
  const result = await PrivateInterceptor(`CalendarioOperativo/CierreInventario`, 'PUT', data);
  return result;
}

export const insertFechasCierreInventario = async(data) =>{
  const result = await PrivateInterceptor(`CalendarioOperativo/CierreInventario`, 'POST', data);
  return result;
}